import { SET_GUEST_NOTICE_VISIBLE } from '../constants/GuestConstants';

export function setGuestNoticeVisible(visible) {
  return {
    type: SET_GUEST_NOTICE_VISIBLE,
    payload: visible,
  };
}
